import {
  shellConfigTelemetryFieldSchema,
  type SerializedBrowserTelemetryConfig,
} from "@bestowinc/tinkertoy-bestow-types";
import { SHELL_CONFIG_ELEMENT_ID } from "@bestowinc/tinkertoy-core";

export type { SerializedBrowserTelemetryConfig };

function hasTelemetryField(value: object): value is { telemetry: unknown } {
  return "telemetry" in value;
}

/**
 * Read and parse the host-injected browser telemetry settings from the shell
 * config JSON blob.
 *
 * Returns `null` when the config element is absent, the blob is malformed, or
 * the telemetry field is missing or invalid. Malformed vendor entries are
 * omitted rather than rejecting the whole telemetry block.
 */
export function readBrowserTelemetryConfig(): SerializedBrowserTelemetryConfig | null {
  const element = document.getElementById(SHELL_CONFIG_ELEMENT_ID);
  if (!element?.textContent) {
    return null;
  }

  try {
    const parsed: unknown = JSON.parse(element.textContent);
    if (typeof parsed !== "object" || parsed === null) {
      return null;
    }
    if (!hasTelemetryField(parsed)) {
      return null;
    }

    const result = shellConfigTelemetryFieldSchema.safeParse(parsed.telemetry);
    if (!result.success || result.data === undefined) {
      return null;
    }
    return result.data;
  } catch {
    return null;
  }
}
